import { Component } from '@angular/core';

@Component({
	selector: 'app-post-out-list',
	templateUrl: './post-out-list.component.html',
	styleUrls: ['./post-out-list.component.css'],
})
export class PostOutListComponent {
	constructor() {}
}
